import IVerificaCargaDisponivelResponse from '../entities/VerificaCargaDisponivelResponse'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IVerificaCargaDisponivel {
  execute(id: number): Promise<IVerificaCargaDisponivelResponse>
}

export default class VerificaCargaDisponivelImpl
  implements IVerificaCargaDisponivel
{
  constructor(private readonly loteRepository: ILoteRepository) {}

  public async execute(id: number): Promise<IVerificaCargaDisponivelResponse> {
    const response = await this.loteRepository.verificaCargaDisponivel(id)

    return response
  }
}
